var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"res-info-card"},[_c('div',{staticClass:"top"},[_c('div',{staticClass:"date"},[_vm._v("2020年02月15日")]),_c('arrow-btn-blue',{attrs:{"copy":"即将开始","from":"/me/res","to":"/me/res"}})],1),_c('div',{staticClass:"bottom"},[_c('time-range',{attrs:{"fs1":30,"fs2":90}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }